const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://adminbackend.ramadreamsgroup.com/api/v1";

const API_ORIGIN = API_BASE_URL.replace(/\/api\/v1\/?$/, "");

const normalizeMediaItem = (item, index) => {
  if (!item?.url) {
    return null;
  }

  const kind = item.kind || (String(item.mimeType || "").startsWith("video/") ? "video" : "image");
  const url = /^https?:\/\//i.test(item.url) ? item.url : `${API_ORIGIN}${item.url}`;

  return {
    id: item.publicId || item.filename || `${kind}-${index}`,
    kind,
    url,
    mimeType: item.mimeType || "",
  };
};

export const mapPublicProperty = (item) => {
  const media = Array.isArray(item?.media)
    ? item.media.map((mediaItem, index) => normalizeMediaItem(mediaItem, index)).filter(Boolean)
    : [];

  return {
    id: item?._id || item?.id || "",
    slug: item?.slug || item?._id || item?.id || "",
    title: item?.title || "Untitled Property",
    location: item?.location || "",
    price: Number(item?.price || 0),
    beds: Number(item?.bedrooms ?? item?.beds ?? 0),
    baths: Number(item?.bathrooms ?? item?.baths ?? 0),
    bathrooms: Number(item?.bathrooms ?? 0),
    toilets: Number(item?.toilets ?? 0),
    kitchens: Number(item?.kitchens ?? 0),
    size: Number(item?.areaSqm ?? item?.size ?? 0),
    description: item?.description || "",
    media,
  };
};

const parseJson = async (response) => {
  const text = await response.text();
  if (!text) {
    return {};
  }
  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
};

const fetchPublic = async (path) => {
  const response = await fetch(`${API_BASE_URL}${path}`);
  const payload = await parseJson(response);

  if (!response.ok) {
    throw new Error(payload.message || "Failed to fetch properties.");
  }

  return payload;
};

export const fetchPublicProperties = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, String(value));
    }
  });

  const suffix = query.toString() ? `?${query.toString()}` : "";
  const payload = await fetchPublic(`/properties/public${suffix}`);

  return {
    data: Array.isArray(payload.data) ? payload.data.map((item) => mapPublicProperty(item)) : [],
    meta: payload.meta || null,
  };
};

export const fetchPublicProperty = async (idOrSlug) => {
  const payload = await fetchPublic(`/properties/public/${encodeURIComponent(idOrSlug)}`);
  return mapPublicProperty(payload.data || {});
};
